import { render, staticRenderFns } from "./registration-in-segment.page.vue?vue&type=template&id=3e042b42&scoped=true"
import script from "./registration-in-segment.page.vue?vue&type=script&lang=ts"
export * from "./registration-in-segment.page.vue?vue&type=script&lang=ts"
import style0 from "./registration-in-segment.page.vue?vue&type=style&index=0&id=3e042b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e042b42",
  null
  
)

export default component.exports